<template>
    <!-- Start Contact Us Section -->
    <section class="contact-us text-center">
        <h1>Contact Us</h1>
        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
        <!-- Start Container -->
        <div class="container">
            <!-- Start Contact Us Form -->
            <form class="contact-us-form">
                <!-- Start Row -->
                <div class="row">
                    <!-- Start Column -->
                    <div class="col-md-6">
                        <input type="text" placeholder="Name" class="form-control" required>
                        <input type="email" placeholder="Email" class="form-control" required>
                        <input type="text" placeholder="Subject" class="form-control" required>
                    </div>
                    <!-- End Column -->
                    <!-- Start Column -->
                    <div class="col-md-6">
                        <textarea placeholder="Message" class="form-control" required></textarea>
                    </div>
                    <!-- End Column -->
                </div>
                <!-- End Row -->
                <button class="btn btn-lg send-message" type="submit" >Send Message</button>
            </form>
            <!-- End Contact Us Form -->
        </div>
        <!-- End Container -->
    </section>
    <!-- End Contact Us Section -->
</template>

<style scoped lang="scss">

    .contact-us{
        padding: var(--main-padding);
        background-color: var(--second-background);
        h1{
            position: relative;
            margin-bottom: 50px;
            &::after{
                content: '';
                position: absolute;
                bottom: -25px;
                left: calc(50% - 50px);
                width: 100px;
                height: 3px;
                background-color: var(--main-color)
            }
        }

        p{
            color: var(--second-color);
            margin-bottom: 50px;
            @media(max-width: 767px){
                margin-bottom: 20px
            }
        }

        form.contact-us-form{
            input:not(:last-child){
                margin-bottom: 20px;
                padding: 10px
            }
            textarea{
                resize: none;
                height: 100%;
                @media(max-width: 767px){
                    margin-top: 20px
                }
            }
            input, textarea{
                padding: 10px;
                text-indent: 10px
            }
            button.send-message{
                background-color: #f0ad4e;
                border-color: #eea236;
                color: #FFF;
                margin-top: 40px;
                &:hover{
                    background-color: #ec971f;
                    border-color: #d58512;
                }
                @media(max-width: 767px){
                    margin: {
                        top: 40px;
                        bottom: 20px
                    }
                    font-size: 18px
                }
            }
        }
    }

</style>

<script>
    export default {
        name: "ContactUs"
    }
</script>